import React, { Component } from "react";
import autoBind from 'react-autobind';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import * as selectors from './redux/reducer';
import Loader from '../../components/Loader';
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import { withStyles } from "@material-ui/core/styles";
import ReactSelect from "react-select";
import {
  Button,
  FormControl,
  InputLabel,
  Input,
  Select,
  FormLabel,
  FormHelperText
} from "@material-ui/core";
import Chip from "@material-ui/core/Chip";
import MenuItem from "@material-ui/core/MenuItem";
import { validateEmpty } from "./Factory";
import CustomChips from "./Factory";
import dp from "./assets/blank-profile.png";
import FollowContributors from "../../components/FollowContributors";
import userInfo from 'utils/userInfo';

const styles = theme => ({
  root: {
    display: "flex",
    flexWrap: "wrap"
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    maxWidth: 300
  },
  chips: {
    display: "flex",
    flexWrap: "wrap"
  },
  chip: {
    margin: theme.spacing.unit / 4
  },
  button: {
    backgroundColor: theme.palette.secondary.main,
    color: "white"
  },
  noLabel: {
    marginTop: theme.spacing.unit * 3
  }
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
      marginTop: 60
    }
  }
}

const MenuProps2 = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
      marginTop: 160
    }
  }
}

const customStyles = {
  option: (provided, state) => ({
    ...provided,
    fontFamily: `"Catamaran", "Roboto", "Helvetica", "Arial", sans-serif`,
    color: state.isSelected ? "rgba(0, 0, 0, 0.54)" : undefined,
    padding: 5,
  }),
  control: (provided, state) => ({
    ...provided,
    fontFamily: `"Catamaran", "Roboto", "Helvetica", "Arial", sans-serif`,
    borderRadius: 0,
    borderStyle: "hidden hidden solid hidden"
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 300ms';

    return { ...provided, opacity, transition };
  }
}

class AddEditContributor extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }
  state = {
    userName: "",
    bio: "",
    email: "",
    number: "",
    cuisines: [],
    cities: [],
    prefCities: [],
    followContributors: [],
    prefCuisines: []
  }
  componentWillMount() {
    let editMode = true;
    this.setState({ editMode });
  }
  componentDidMount() {
    this.setState({ id: userInfo.getUserID() });
    this.props.dispatch(actions.getData(userInfo.getUserID())).then(() => {
      if (this.state.editMode) {
        let user = this.props.user;
        let userName = user.displayName;
        let linkName = user.userName;
        let url = user.profilePic ? user.profilePic.uri : "/icons/user.png";
        let city = user.userProfile.hometown ? user.userProfile.hometown.name : "";
        let bio = user.userProfile.bio;
        let email = user.contactDetails.email;
        let number = user.contactDetails.phoneNumber ? user.contactDetails.phoneNumber : "";
        let cities = user.citiesOfExpertise.map(city => city.name);
        let cuisines = user.cuisinesOfExpertise.map(cuisine => cuisine.name);
        this.setState({ userName, url, city, bio, email, number, cities, cuisines, linkName });
      }
    });
  }
  handleImageUpload = event => {
    this.setState({
      file: event.target.files[0],
      url: URL.createObjectURL(event.target.files[0])
    });
  };
  handleSubmit = (e) => {
    e.preventDefault();
    let isError = false;
    let errors = {
      ...this.validateCity(),
      ...this.validatePrefCity(),
      ...this.validatePrefCuisines(),
      ...this.validateFollowContributors()
    }
    for (let key in errors) {
      if (errors[key] === true) {
        isError = true;
      }
    }
    // this.matchPasswords(this.state.password, this.state.rePassword);
    if (this.state.userNameErrorStatus || !this.state.url || this.state.bioErrorStatus || this.state.passwordUnmatchStatus || this.state.cityErrorStatus) {
      isError = true;
    }
    if (this.state.cities.length === 0 || this.state.cuisines.length === 0) {
      isError = true;
    }
    this.setState({ isError });
    if (!isError) {
      let data = this.props.user;
      let redirectUri = userInfo.isContributor() ? `/contributor_experience/${userInfo.getUserID()}` : `/user_profile/${this.state.linkName}`;
      if (this.state.file) {
        this.props.dispatch(actions.postFile(this.state.file)).then(() => {
          if (this.props.fileResp) {
            if (this.props.fileResp["data"] && this.props.fileResp["data"].length > 0) {
              let imgData = this.props.fileResp["data"][0];
              data.profilePic["uri"] = imgData.fileDownloadUri;
              data.profilePic["name"] = imgData.fileName;
              data.displayName = this.state.userName;
              data.userProfile.hometown = this.props.citiesGot.find(city => this.state.city === city.cityName);
              data.userProfile.bio = this.state.bio;
              data.contactDetails.email = this.state.email;
              data.contactDetails.phoneNumber = this.state.number;
              data.citiesOfExpertise = this.props.citiesGot.filter(city => this.state.cities.indexOf(city.cityName) !== -1);
              data.cuisinesOfExpertise = this.props.cuisines.filter(cuisine => this.state.cuisines.indexOf(cuisine.name) !== -1);
              this.props.dispatch(actions.postData(userInfo.getUserID(), data)).then(() => this.props.history.push(redirectUri));
            }
          }
        });
      } else {
        data.displayName = this.state.userName;
        data.userProfile.hometown = this.props.citiesGot.find(city => this.state.city === city.cityName);
        data.userProfile.bio = this.state.bio;
        data.contactDetails.email = this.state.email;
        data.contactDetails.phoneNumber = this.state.number;
        data.citiesOfExpertise = this.props.citiesGot.filter(city => this.state.cities.indexOf(city.cityName) !== -1);
        data.cuisinesOfExpertise = this.props.cuisines.filter(cuisine => this.state.cuisines.indexOf(cuisine.name) !== -1);
        this.props.dispatch(actions.postData(userInfo.getUserID(), data)).then(() => this.props.history.push(redirectUri));
        console.log("form data:", data);
      }
    }
  }
  validateCity = () => {
    let errors = validateEmpty("cityError", this.state.city, "cityErrorStatus", "City is Required");
    this.setState({ ...this.state, ...errors });
    return errors;
  }
  validateUsername = () => {
    let errors = validateEmpty("userNameError", this.state.userName, "userNameErrorStatus", "UserName is required");
    this.setState({ ...this.state, ...errors });
  }
  validateBio = () => {
    let errors = validateEmpty("bioError", this.state.bio, "bioErrorStatus", "Bio is required");
    this.setState({ ...this.state, ...errors });
  }
  validateEmail = () => {
    let errors = validateEmpty("emailError", this.state.email, "emailErrorStatus", "Email is required");
    this.setState({ ...this.state, ...errors });
  }
  validateNumber = () => {
    let errors = validateEmpty("numberError", this.state.number, "numberErrorStatus", "Mobile Number is required");
    this.setState({ ...this.state, ...errors });
  }
  validatePassword = () => {
    let errors = validateEmpty("passwordError", this.state.password, "passwordErrorStatus", "Password is required");
    this.setState({ ...this.state, ...errors });
  }
  validatePrefCity = () => {
    let errors = validateEmpty("prefCitiesError", this.state.prefCities, "prefCitiesErrorStatus", "Cities are required");
    this.setState({ ...this.state, ...errors });
    return errors;
  }
  validatePrefCuisines = () => {
    let errors = validateEmpty("prefCuisinesError", this.state.prefCuisines, "prefCuisinesErrorStatus", "Cuisines are Required");
    this.setState({ ...this.state, ...errors });
    return errors;
  }
  validateFollowContributors = () => {
    let errors = validateEmpty("followContributorsError", this.state.followContributors, "followContributorsErrorStatus", "Follow atleast 1 contributor");
    this.setState({ ...this.state, ...errors });
    return errors;
  }
  matchPasswords(p1, p2) {
    let errors = {};
    if (!(p2 === p1)) {
      errors["passwordUnmatchErrorStatus"] = true;
      errors["passwordUnmatchError"] = "Passwords Do Not Match"
    } else {
      errors["passwordUnmatchErrorStatus"] = false;
      errors["passwordUnmatchError"] = ""
    }
    this.setState({ ...this.state, ...errors });
  }
  handlePrefCities = (e) => {
    this.setState({ prefCities: e }, () => this.validatePrefCity());
  }
  handleFollowContributors = (e) => {
    this.setState({ followContributors: e }, () => this.validateFollowContributors());
  }
  render() {
    const { classes, loading, homeCity, cities, contributors, cuisineNames } = this.props;
    let isUser = !userInfo.isContributor();
    if (isUser === null) {
      alert("User doesn't exists");
    }
    if (loading) {
      return (
        <Loader />
      )
    }
    else {
      return (
        <form style={{ margin: "10%" }} onSubmit={this.handleSubmit} >
          <Typography component="h5" variant="h4" gutterBottom>
            {!isUser ? (!this.state.editMode ? "Contributor Sign-up" : "Update Profile") : (!this.state.editMode ? "User Sign-up" : "Update User")}
          </Typography>
          <TextField
            fullWidth
            required
            error={this.state.userNameErrorStatus}
            helperText={this.state.userNameError}
            value={this.state.userName ? this.state.userName : ""}
            onChange={e =>
              this.setState({ userName: e.target.value }, () =>
                this.validateUsername()
              )
            }
            id="contributor-name"
            label="Name" // Display Name
            placeholder="12 places for the best Mysore pak in Bangalore "
            // className={classes.textField}
            margin="dense"
          />
          <input
            accept="image/*"
            ref={instance => (this.upload = instance)}
            onChange={this.handleImageUpload}
            type="file"
            hidden
          />
          {/* <Button
          component="span"
          variant="contained"
          onClick={() => this.upload.click()}
        >
          User Image
        </Button> */}
          <br />
          <br />
          <img
            src={this.state.url ? this.state.url : dp}
            alt="No Img"
            onClick={() => this.upload.click()}
            style={{ height: "200px", width: "200px" }}
          />
          <p>Click on the image to change picture</p>
          {this.state.isError && !this.state.url ? <div style={{ color: "red" }}>Image is required</div> : null}
          <br />
          <FormControl
            className="w-full"
            error={this.state.isError || this.state.cityErrorStatus}
            margin="normal"
            required
          >
            <FormLabel component="legend" >Home City</FormLabel>
            <br />
            <ReactSelect
              id="city"
              options={cities}
              styles={customStyles}
              theme={(theme) => ({
                ...theme,
                colors: {
                  ...theme.colors,
                  primary: undefined,
                },
              })}
              value={this.state.city ? { label: this.state.city, value: this.state.city } : undefined}
              onChange={e => this.setState({ city: e ? e.label : e })}
              placeholder="Select City"
            />
            <FormHelperText>{this.state.cityError}</FormHelperText>
          </FormControl>
          <TextField
            fullWidth
            required
            value={this.state.bio ? this.state.bio : ""}
            onChange={e => this.setState({ bio: e.target.value }, () => this.validateBio())}
            id="contributor-bio"
            label="Bio"
            error={this.state.bioErrorStatus}
            helperText={this.state.bioError}
            multiline
            placeholder="tell us about yourself... "
            // className={classes.textField}
            margin="normal"
          />
          <br />
          <br />
          {!isUser && (<fieldset className="mx-0 mt-4 px-4">
            <FormLabel className="px-1" component="legend">
              Experts In
            </FormLabel>
            <br />
            <FormControl
              required
              fullWidth
            >
              <InputLabel htmlFor="cities">Cities</InputLabel>
              <Select
                fullWidth
                multiple
                value={this.state.cities}
                onChange={e => this.setState({ cities: e.target.value })}
                input={<Input id="cities" />}
                renderValue={selected => (
                  <div className={classes.chips}>
                    {selected.map(value => (
                      <Chip key={value} label={value} className={classes.chip} />
                    ))}
                  </div>
                )}
                MenuProps={MenuProps2}
              >
                {homeCity.map(name => (
                  <MenuItem key={name} value={name}>
                    {name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {(this.state.isError && this.state.cities.length === 0) ? <div style={{ color: "red" }}>Cities are required</div> : null}
            <br />
            <br />
            <FormControl
              required
              fullWidth
            >
              <InputLabel htmlFor="cuisines">Cuisines and Dishes</InputLabel>
              <Select
                fullWidth
                multiple
                value={this.state.cuisines}
                onChange={e => this.setState({ cuisines: e.target.value })}
                input={<Input id="cuisines" />}
                renderValue={selected => (
                  <div className={classes.chips}>
                    {selected.map(value => (
                      <Chip key={value} label={value} className={classes.chip} />
                    ))}
                  </div>
                )}
                MenuProps={MenuProps2}
              >
                {cuisineNames.map(name => (
                  <MenuItem key={name} value={name}>
                    {name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {(this.state.isError && this.state.cuisines.length === 0) ? <div style={{ color: "red" }}>Cuisines and dishies are required</div> : null}
            <br />
            <br />
          </fieldset>
          )}
          <br />
          <br />
          <fieldset className="mx-0 mt-4 px-4">
            <FormLabel className="px-1" component="legend">
              Basic Settings
          </FormLabel>
            <br />
            <TextField
              fullWidth
              required
              type="email"
              error={this.state.emailErrorStatus}
              helperText={this.state.emailError}
              value={this.state.email ? this.state.email : ""}
              onChange={e => this.setState({ email: e.target.value }, () => this.validateEmail())}
              label="Email"
              placeholder="example john@example.com"
              margin="dense"
            />
            <br />
            <TextField
              fullWidth
              required
              type="number"
              error={this.state.numberErrorStatus}
              helperText={this.state.numberError}
              value={this.state.number ? this.state.number : ""}
              onChange={e => this.setState({ number: e.target.value }, () => this.validateNumber())}
              label="Mobile Number"
              placeholder="Mobile Number"
              margin="dense"
            />
            <br />
            {/* To Change password use forgot password option.0 */}
            {/* <TextField
            fullWidth
            required
            type="password"
            error={this.state.passwordErrorStatus}
            helperText={this.state.passwordError}
            value={this.state.password}
            onChange={e => this.setState({ password: e.target.value }, () => this.validatePassword() )}
            label="Password"
            placeholder="Password "
            margin="dense"
          />
          <br/>
          <TextField
            fullWidth
            required
            type="password"
            error={this.state.passwordUnmatchErrorStatus}
            helperText={this.state.passwordUnmatchError}
            value={this.state.rePassword}
            onChange={e => this.setState({ rePassword: e.target.value })}
            onBlur={e => this.matchPasswords(e.target.value,this.state.password)}
            label="Re-enter Password"
            placeholder="Re-enter Password"
            margin="dense"
          />
          <br/> */}
            <br />
          </fieldset>
          <br />
          <br />
          <fieldset className="mx-0 mt-4 px-4">
            <FormLabel className="px-1" component="legend">
              My Preferences
          </FormLabel>
            <FormControl
              required
              fullWidth
              error={this.state.prefCitiesErrorStatus}
            // className={classes.formControl}
            >
              <label htmlFor="pref-cities">
                Locations I'm Interested in
            </label>
              <br />
              <CustomChips id="pref-cities" options={homeCity} style={classes.button} value={this.state.prefCities} onChange={this.handlePrefCities} />
              <FormHelperText>{this.state.prefCitiesError}</FormHelperText>
            </FormControl>
            <br />
            <FormControl
              required
              fullWidth
              error={this.state.prefCuisinesErrorStatus}
            // className={classes.formControl}
            >
              <InputLabel htmlFor="pref-Cuisines">
                Cuisines and Dishes I'm Interested in
              </InputLabel>
              <Select
                fullWidth
                name="Cuisines and Dishes I'm Interested in"
                multiple
                value={this.state.prefCuisines}
                onChange={e => this.setState({ prefCuisines: e.target.value }, () => this.validatePrefCuisines())}
                input={<Input id="pref-Cuisines" />}
                renderValue={selected => (
                  <div className={classes.chips} >
                    {selected.map(value => (
                      <Chip key={value} label={value} className={classes.chip} />
                    ))}
                  </div>
                )}
                MenuProps={MenuProps}
              >
                {cuisineNames.map(name => (
                  <MenuItem key={name} value={name}>
                    {name}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>{this.state.prefCuisinesError}</FormHelperText>
            </FormControl>
            <br />
            <FormControl
              required
              fullWidth
              error={this.state.followContributorsErrorStatus}
            >
              <FormLabel htmlFor="followContributors">
                Follow Contributors
              </FormLabel>
              <br />
              <FollowContributors id="followContributors" data={contributors} value={this.state.followContributors} onChange={this.handleFollowContributors} />
              <FormHelperText>{this.state.followContributorsError}</FormHelperText>
            </FormControl>
            <br />
          </fieldset>
          <br />
          <br />
          <fieldset className="mx-0 mt-4 px-4">
            <FormLabel className="px-1" component="legend">
              Social Media Links
          </FormLabel>
            <br />
            <TextField
              fullWidth
              type="url"
              value={this.state.facebook ? this.state.facebook : ""}
              onChange={e => this.setState({ facebook: e.target.value })}
              label="Facebook"
              placeholder="Link to your Facebook Page"
              margin="dense"
            />
            <br />
            <TextField
              fullWidth
              type="url"
              value={this.state.youtube ? this.state.youtube : ""}
              onChange={e => this.setState({ youtube: e.target.value })}
              label="YouToube"
              placeholder="Link to your channel"
              margin="dense"
            />
            <br />
            <TextField
              fullWidth
              type="url"
              value={this.state.twitter ? this.state.twitter : ""}
              onChange={e => this.setState({ twitter: e.target.value })}
              label="Twitter"
              placeholder="Twitter"
              margin="dense"
            />
            <br />
            <TextField
              fullWidth
              type="url"
              value={this.state.instagram ? this.state.instagram : ""}
              onChange={e => this.setState({ instagram: e.target.value })}
              label="Instagram"
              placeholder="Instagram"
              margin="dense"
            />
            <br />
            <br />
          </fieldset>
          <br />
          <br />
          <Button
            type="submit"
            className={classes.button}
            variant="contained"
          // onClick={e => this.handleSubmit()}
          >
            {!isUser ? (!this.state.editMode ? "Add Profile" : "Update Profile") : (!this.state.editMode ? "Add User" : "Update User")}
          </Button>
        </form>
      );
    }
  }
}

function mapStateToProps(state) {
  return selectors.getAllValues(state);
}

export default connect(mapStateToProps)(withStyles(styles)(AddEditContributor));
